import { X } from 'lucide-react';

/**
 * Close affordance for the standalone public viewer pages, which open with no
 * app navigation chrome.
 *
 * Always rendered. Email clients open these links with rel="noopener", so the
 * tab has no opener and a single-entry session history — and per the HTML spec
 * that is exactly what makes a top-level tab script-closable, so
 * window.close() works there. (The previous visibility rule hid the button in
 * that case, leaving email recipients with a navigational dead end.) Pages
 * reached with in-app history instead fall back to history.back(). Only a
 * webview that blocks close() with no history turns the click into a no-op —
 * and in-app browsers supply their own Done/X chrome anyway.
 */
export function PublicPageCloseButton() {
  const onClose = () => {
    window.close();
    // If close() was blocked (same-tab open with history), fall back to going
    // back. The 150ms delay lets a successful close() take effect first.
    setTimeout(() => {
      if (!window.closed && window.history.length > 1) window.history.back();
    }, 150);
  };

  return (
    <button
      type="button"
      onClick={onClose}
      aria-label="Close"
      className="inline-flex items-center justify-center w-11 h-11 rounded text-slate-500 hover:text-slate-700"
    >
      <X size={20} />
    </button>
  );
}
